<template>
  <div>
    <payin-form
      :is-active.sync="isEditing"
      method="put"
      :fee="editingFeeConfiguration"
      @changed="feeConfigurationUpdated"
    />
    <payin-form :is-active.sync="isAdding" @changed="feeConfigurationAdded" />
    <data-table
      title="Transfer PayInMethods"
      ref="table"
      :url="url"
      :headers="headers"
      :archive="false"
      item-key="id"
      searchable
      @click:row="showFeeConfigurationDetails"
    >
      <v-btn slot="action.icons" color="primary" @click="isAdding = true">
        Add a payin method
        <v-icon class="ml-2" color="light-blue lighten-4"> mdi-account-money</v-icon>
      </v-btn>
    </data-table>
  </div>
</template>
<script>
import PayinForm from "./form.vue";
export default {
  components: {
    PayinForm,
  },
  data() {
    return {
      isAdding: false,
      isEditing: false,
      offer: {},
      editingFeeConfiguration: null,
      url: `api/v1/transactions/feeConfigurations/${this.$route.params.id}/payinMethodTransfer`,
      headers: this.pairTableLabelWithValue({
        PayInMethod: "cash_in_method.name",
        Country: "country.name",
        FeeType: "fee_type.name",
        Min: "cash_in_method.min_amount",
        Max: "cash_in_method.max_amount",
      }),
    };
  },
  watch: {
    url() {
      this.$nextTick(() => {
        this.$refs.table.fetchData();
      });
    },
  },
  computed: {
    feeConfigurationId() {
      return this.$route.params.id;
    },
  },

  methods: {
    showFeeConfigurationDetails({ id }) {
      return this.$router.push({
        name: "instantTransfers.payinmethods.show",
        params: { id, feeConfigurationId: this.feeConfigurationId },
      });
    },
    feeConfigurationAdded({ message }) {
      this.isAdding = false;
      Notify.success(message);
      // refresh the table data
      this.$refs.table.fetchData();
    },
    feeConfigurationUpdated({ message }) {
      this.editingFeeConfiguration = null;
      this.isUpdating = false;
      Notify.success(message);
      // refresh the table data
      this.$refs.table.fetchData();
    },
    updateOffer(offer) {
      this.editingFeeConfiguration = Object.assign({}, offer);
      this.isEditing = true;
    },
  },
};
</script>
